import Vue from 'vue'
import App from './App.vue'
import VueGoogleCharts from 'vue-google-charts'
import {router} from './router'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(VueGoogleCharts);

Vue.component('font-awesome-icon', FontAwesomeIcon);

// hides default console message
Vue.config.productionTip = false;
// control inspection of code using vue devtools - set to false for production
Vue.config.devtools = true;

Vue.config.errorHandler = function(err, vm, info) {
  console.log(`Error: ${err.toString()}\nInfo: ${info}`);
};

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
